document.addEventListener("DOMContentLoaded", function () {

  const interval = setInterval(async () => {

    const formEmbed = document.querySelector('[data-forms-id="forms-root-752760"] shopify-forms-embed');

    // wait until shadow root loaded
    if (!formEmbed || !formEmbed.shadowRoot) return;

    clearInterval(interval);

        const shadow = formEmbed.shadowRoot;
        if (!shadow) return;

        const linkTag = document.createElement("link");
        linkTag.rel = "stylesheet";
        linkTag.href = RegistrationForm;   
        linkTag.type = "text/css";
        linkTag.id = "registration-form-css";
        formEmbed.shadowRoot.appendChild(linkTag);

        const el = document.querySelector('[data-forms-id="forms-root-752760"]');
        if (el) {
          el.style.display = "block";
        }

        const emailInput  = shadow.querySelector('#email');
        const submitBtn   = shadow.querySelector('[data-testid="btn-form-submit"]');
        if (!emailInput || !submitBtn) return;

        submitBtn.disabled = true;
        submitBtn.style.opacity = "0.5";

        const errorMsg = document.createElement("div");
        errorMsg.textContent = "Please enter a valid email with an approved domain: armakuni.com, amazon.com, or amazon.co.uk";
        errorMsg.style.color = "#E02229";
        errorMsg.style.fontSize = "13px";
        errorMsg.style.marginTop = "5px";
        errorMsg.style.display = "none";
        emailInput.parentNode.appendChild(errorMsg);

        function setErrorStyles(input) {
          input.style.border = "2px solid #E02229";
        }
        function clearErrorStyles(input) {
          input.style.border = "";
        }

        const allowedDomains = ["@armakuni.com", "@amazon.com", "@amazon.co.uk"];

    emailInput.addEventListener("input", function () {
      const v = emailInput.value.toLowerCase().trim();
      const isValid = allowedDomains.some(domain => v.endsWith(domain));

      if (isValid) {
        submitBtn.disabled = false;
        submitBtn.style.opacity = "1";
        clearErrorStyles(emailInput);
        errorMsg.style.display = "none";
      } else {
        submitBtn.disabled = true;
        submitBtn.style.opacity = "0.5";
        setErrorStyles(emailInput);
        errorMsg.style.display = "block";
      }
    });

    const onlyTextFields = [
      { id: "#custom\\#city", name: "City" },
      { id: "#custom\\#stateprovince", name: "State/Province" },
      { id: "#custom\\#country", name: "Country" },
      { id: "#first_name", name: "Firstname" }
    ];
    onlyTextFields.forEach(f => {
      const field = shadow.querySelector(f.id);
      if (!field) return;

      const err = document.createElement("div");
      err.textContent = f.name + " can contain only letters (A–Z), no numbers allowed";
      err.style.color = "#E02229";
      err.style.fontSize = "13px";
      err.style.display = "none";
      err.style.marginTop = "5px";

      const wrapper = field.closest('[data-field-wrapper], div, section');
      wrapper.appendChild(err);

      field.addEventListener("input", function (e) {

        const rawValue = e.target.value;
        const cleaned  = rawValue.replace(/[^A-Za-z\\s]/g, "");
        const invalid = rawValue !== cleaned;

        field.value = cleaned;

        if (invalid) {
          setErrorStyles(field);
          err.style.display = "block";
          submitBtn.disabled = true;
          submitBtn.style.opacity = "0.5";
          return;
        }

        clearErrorStyles(field);
        err.style.display = "none";

        const emailValid = allowedDomains.some(domain =>
          emailInput.value.trim().toLowerCase().endsWith(domain)
        );

        if (emailValid) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = "1";
        }
      });

    });


  }, 200); // checks every 200ms until ready

});
